const config = {
    apiUrl: process.env.REACT_APP_API_SERVER || 'http://beskidyapi.local',
    // Statyczne kafle PMTiles + style.json mapy Karpat (repo beskidy-map, docs/DEPLOYMENT.md).
    tilesUrl: process.env.REACT_APP_TILES_URL || 'https://tiles.geo.gallery',
};

export default config;